import YouTubeEmbed from '@/components/YouTubeEmbed';

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

const TTBF002CP = () => {
  return (
    <div className='mx-auto mt-5 max-w-[1440px] lg_mt-[0px]'>
      <YouTubeEmbed videoId={'BzdEZ8-WDA8'} />

      <div className='hidden lg_block'>
        <img
          className='my-2 w-full'
          src='/images/TTBF002CP/PC/1.jpg'
        />
        <img
          className='mt-2 w-full'
          src='/images/TTBF002CP/PC/2.jpg'
        />
        <img
          className='mb-2 w-full'
          src='/images/TTBF002CP/PC/3.jpg'
        />
        <img
          className='my-2 w-full'
          src='/images/TTBF002CP/PC/4.jpg'
        />
        <img
          className='my-2 w-full'
          src='/images/TTBF002CP/PC/5.jpg'
        />
        <img
          className='my-2 w-full'
          src='/images/TTBF002CP/PC/6.jpg'
        />
        <img
          className='my-2 w-full'
          src='/images/TTBF002CP/PC/7.webp'
        />
        <img
          className='mx-auto my-2 w-4/5'
          src='/images/TTBF002CP/PC/8.webp'
        />
      </div>

      <div className='lg_hidden'>
        <img
          className='my-2 w-full'
          src='/images/TTBF002CP/M/M-1.jpg'
        />
        <img
          className='mt-2 w-full'
          src='/images/TTBF002CP/M/M-2.jpg'
        />
        <img
          className='mb-2 w-full'
          src='/images/TTBF002CP/M/M-3.jpg'
        />
        <img
          className='my-2 w-full'
          src='/images/TTBF002CP/M/M-4.jpg'
        />
        <img
          className='my-2 w-full'
          src='/images/TTBF002CP/M/M-5.jpg'
        />
        <img
          className='my-2 w-full'
          src='/images/TTBF002CP/M/M-6.jpg'
        />
        <img
          className='my-2 w-full'
          src='/images/TTBF002CP/M/M-7.webp'
        />
        <img
          className='mx-auto my-2 w-[90%]'
          src='/images/TTBF002CP/M/M-8.webp'
        />
      </div>

      <div className='px-[17px] lg_px-0'>
        <h2 className='py-[20px] text-center font-poppins text-[24px]'>Frequently Asked Questions</h2>
        <Accordion
          type='multiple'
          className='mt-[20px] w-full border-t border-[#EFEFEF] lg_mt-[40px]'
          defaultValue={[]}
        >
          <AccordionItem value='item-1'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>How does the smart bird feeder work?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                Our smart bird feeder features a builtin HD camera and Al bird recognition. It detects bird activity,
                automatically captures photos/videos, and sends real-time alerts to your phone via the app.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-2'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>Does it require a Wi-Fi connection?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                Yes, it connects to 2.4GHz Wi-Fi to stream live video and enable app notifications. Some models also
                support SD card recording in case of network interruptions.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-3'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>Can I watch birds live on my phone?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                Absolutely Simply download the Titto companion app to view live footage, receive visitor notifications,
                take snapshots, and even share moments with family or friends.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-4'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>What birds can I attract with this feeder?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                It's ideal for seed-loving birds such as Cardinals, Chickadees, Goldfinches, Sparrows, Titmice and
                thousands of bird species.Just fill it with the right type of seed and you'll start seeing visits.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-5'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>What kind of bird seed should I use?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                We recommend black oil sunflower seeds, mixed seeds, or crushed peanuts. Avoid sticky or moist foods to
                prevent clogs.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-6'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>Does it support night vision?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                Yes,it features infrared or full-color night vision (depending on the model) to help you enjoy
                birdwatching even after dark.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-7'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>Do I need to recharge it often?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                No. With the integrated solar panel, the feeder can stay powered with minimal charging. USB charging is
                available as a backup on some models.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-8'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>Is it weatherproof? Can it stay outdoors year-round?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                Yes, all models are IP65 weatherproof—designed to withstand rain, snow, and sun so you can enjoy
                birdwatching year-round.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-9'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>Is it easy to clean? Does the camera require special care?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                Yes. The feeder tray is removable for easy cleaning. We recommend wiping the camera lens gently with a
                damp cloth every 1-2 weeks to maintain clear visibility.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-10'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>Is there a user guide or tutorial for the app?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                Yes, you'l receive a quick start guide in the package and follow the tutorial to start your smart bird
                watching trip. We have iOS and Android App support.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-11'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>What's the warranty policy?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                We offer a 30-day free warranty covering non-human damage and 6 months extra warranty if you register
                warranty on our website.
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  );
};

export default TTBF002CP;
